"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GAME_VERSIONS = void 0;
exports.GAME_VERSIONS = ["standard", "us", "ntu"];
